/**
 * @desc 交易排名查询
 */
import {
  TradingRankingEntity,
  MallTradingRankingQuery
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryMallTradingRankingListParameter = MallTradingRankingQuery

const method = 'GET'
const url = '/trade/mall/tradingRanking/list'

export const queryMallTradingRankingListApi = (
  params?: QueryMallTradingRankingListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<TradingRankingEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryMallTradingRankingListApi.method = method
queryMallTradingRankingListApi.url = url
